

export const Constants = {
  COMPONENT_OPTIONS_KEY: "nuxtI18n",
  STRATEGIES: {"PREFIX":"prefix","PREFIX_EXCEPT_DEFAULT":"prefix_except_default","PREFIX_AND_DEFAULT":"prefix_and_default","NO_PREFIX":"no_prefix"},
}
export const nuxtOptions = {
  isUniversalMode: false,
  trailingSlash: undefined,
}
export const options = {
  vueI18n: {"fallbackLocale":"en","silentFallbackWarn":true,"messages":{"en":{"navigation":{"welcome":"Welcome","welcome-dashboard":"Dashboard","network":"Network","network-exports":"Exports"},"pg":{"exports":{"renewedSystemsExport":"Renewed systems export","downloadXlsExport":"Download XLS","downloadJsonExport":"Download JSON","expiringSystemsExport":"Expiring systems export","pleaseSelectFirstOrganizationAndDateRange":"Please select first a date range.","includeOptionalModules":"Include optional modules","searchCompany":"Search company"}},"common":{"exports":"Exports","network":"Network","organization":"Organization","chooseOrganization":"Choose organization","chooseRegion":"Choose region","from":"From","to":"To","worldwide":"Worldwide","nextmedia":"Nextmedia","dach":"Dach","japan":"Japan","italy":"Italy","australia":"Australia","america":"America"}},"it":{}}},
  vueI18nLoader: false,
  locales: ["en","it"],
  defaultLocale: "en",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  defaultLocaleRouteNameSuffix: "default",
  sortRoutes: true,
  strategy: "no_prefix",
  lazy: false,
  langDir: null,
  rootRedirect: null,
  detectBrowserLanguage: {"alwaysRedirect":false,"cookieCrossOrigin":false,"cookieDomain":null,"cookieKey":"i18n_redirected","cookieSecure":false,"fallbackLocale":"","onlyOnNoPrefix":false,"onlyOnRoot":false,"useCookie":true},
  differentDomains: false,
  seo: false,
  baseUrl: "",
  vuex: {"moduleName":"i18n","syncLocale":false,"syncMessages":false,"syncRouteParams":true},
  parsePages: true,
  pages: {},
  skipSettingLocaleOnNavigate: false,
  beforeLanguageSwitch: () => null,
  onBeforeLanguageSwitch: () => {},
  onLanguageSwitched: () => null,
  normalizedLocales: [{"code":"en"},{"code":"it"}],
  localeCodes: ["en","it"],
}

export const localeMessages = {}
